"use client";

import { themeColors } from "@/utils/themeColors";
import { UserDetails } from "@knowt/syncing/graphql/schema";
import { isDarkColor } from "@knowt/syncing/utils/genericUtils";
import { useEffect, useRef } from "react";
import { PROFILE_HEADER_ID, setDynamicHeaderColorCssVar } from "../../../../utils/colors";

const ProfileHeaderInitialColorHandler = ({ user }: { user: UserDetails }) => {
    // NOTE: SelectedColor has a default value == "var(--color-card-primary)" saved in db. So, it will never be `null` esentially.
    // Our css module also set `var(--color-profile-dynamic-text-color)` to `var(--color-card-primary)`. So, on any bad case
    // it's falsy, we should be safe to not do `initialColorSetter`
    const selectedColor = user.profileColor as string;

    const profileHeaderRef = useRef<HTMLElement | null>(null);
    useEffect(() => {
        profileHeaderRef.current = document.getElementById(PROFILE_HEADER_ID);
    }, []);

    // initialColorSetter
    useEffect(() => {
        if (!selectedColor) {
            return;
        }

        const isDarkBackground = isDarkColor(selectedColor);

        setDynamicHeaderColorCssVar(profileHeaderRef.current, {
            backgroundColor: selectedColor,
            color: isDarkBackground ? themeColors.pureWhite : themeColors.pureBlack,
        });
    }, [selectedColor]);

    return null;
};

export default ProfileHeaderInitialColorHandler;
